import { Box } from '@mui/material'
import ReleaseCheckNav from './ReleaseCheckNav'
import ReleaseCheckRoutes from './ReleaseCheckRoutes'

const ReleaseCheckLayout = () => {
  return (
    <>
      <ReleaseCheckNav />
      <Box sx={{ px: 3 }}>
        <ReleaseCheckRoutes />
      </Box>
    </>
  )
}

export default ReleaseCheckLayout
